export const Whitelist: string[] = [];
Whitelist.includes = (_string: string) => {
  return true;
};
